export default function getHash(str = '') {
  return str
    .toLowerCase()
    .replace(/ /g, '-')
    .replace(/[^a-z0-9а-я-]/g, '')
    .replace(/-{2,}/g, '-');
}
